var __defProp = Object.defineProperty;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var _onCartUpdate;
import { Component } from "@theme/component";
import { ThemeEvents } from "@theme/events";
class HeaderActions extends Component {
  constructor() {
    super(...arguments);
    __publicField(this, "requiredRefs", ["liveRegion"]);
    /**
     * Handles cart update events and announces the new count to screen readers.
     * @param {CustomEvent<{ resource?: { item_count?: number } }>} event
     */
    __privateAdd(this, _onCartUpdate, (event) => {
      const cartCount = event.detail.resource?.item_count;
      if (cartCount === void 0) return;
      this.refs.liveRegion.textContent = `${Theme.translations.cart_count}: ${cartCount}`;
    });
  }
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(ThemeEvents.cartUpdate, __privateGet(this, _onCartUpdate));
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(ThemeEvents.cartUpdate, __privateGet(this, _onCartUpdate));
  }
}
_onCartUpdate = new WeakMap();
if (!customElements.get("header-actions")) {
  customElements.define("header-actions", HeaderActions);
}
